<template>
  <!-- OUTIL DE RECHERCHE -->
    <ApplicationHeaderButton
      class="d-none d-lg-flex"
      id="applicationSearcher"
      :buttonConfig="computedConfig"
      comment="Accéder à la recherche"
      iconName="dgfipicon-rechercher"
      buttonText="Rechercher"
      @click.native="$emit('toggleInput')"
      @keypress.native.enter="$emit('toggleInput')"
    ></ApplicationHeaderButton>
</template>

<script>
import ApplicationHeaderButton from "./ApplicationHeaderButton";

export default {
  name: "SearchButton",
  props: {
    searchConfig: { type: Object, default: () => {} }
  },
  computed: {
    computedConfig() {
      return Object.assign({}, this.searchConfig, {
        iconName: "dgfipicon-rechercher",
        text: "Rechercher",
        comment: this.$store.getters["user/fullname"]
      });
    }
  },
  components: {
    ApplicationHeaderButton
  }
};
</script>